var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('i-money',{staticClass:"primary--text font-weight-bold headline",attrs:{"value":_vm.price,"mode":"text"}}):_c('v-skeleton-loader',{attrs:{"type":"text","tile":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }